import React from 'react';
/** icon-checkmark-strong-l */
/** icon-checkmark-strong */
export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M19.723 4.727 C 19.647 4.748,19.503 4.821,19.403 4.888 C 19.302 4.956,16.921 7.308,14.110 10.115 L 9.001 15.219 6.890 13.115 C 5.730 11.958,4.696 10.955,4.593 10.886 C 4.180 10.608,3.762 10.626,3.346 10.937 C 3.217 11.033,3.033 11.217,2.937 11.346 C 2.626 11.761,2.608 12.180,2.886 12.593 C 3.053 12.843,7.989 17.792,8.320 18.042 C 8.762 18.376,9.168 18.399,9.593 18.115 C 9.841 17.948,20.789 7.014,21.042 6.680 C 21.396 6.211,21.403 5.800,21.063 5.346 C 20.672 4.824,20.178 4.596,19.723 4.727 "
            stroke="none"
            fillRule="evenodd"
            fill="#1A2B49"
        />
    </svg>
);
